import React, { Dispatch } from "react";
import DelegationForm from "../DelegationForm/DelegationForm";
import { RootReducer } from "../../store/reducers";
import { connect } from "react-redux";
import useFleetManagerContext from "../../context/hooks/useFleetManagerContext";
import parkingProductsActions from "../../store/actions/parkingProducts.actions";
import { ParkingRightsRequestModel } from "../../models/ParkingRightsRequestModel";
import { DelegationFormDetails } from "../DelegationForm/DelegationFormDetails";

interface IDelegeeProps extends StateProps, DispatchProps {
    onClose: () => void;
    refreshHandler: () => void;
    registrationId: string;
  }

const ParkingRightsForm: React.FC<IDelegeeProps> = (props) => {
  const {
    parkingProducts,
    getParkingProducts,
    delegateParkingRights,
    updateDelegation,
    getDelegeeDetails,
    clearDelegeeDetails,
    resetBulkImportProgress,
    getBulkImportStatus,
    disposeError
  } = props;

  const getDelegationFormDetails = () => {
    const details: DelegationFormDetails = {
       delegeeDetails: parkingProducts.delegeeDetails,
       parkingProducts: parkingProducts.parkingProducts,
       error: parkingProducts.error,
       isBulkImportCompleted: parkingProducts.isBulkImportCompleted,
       loading: parkingProducts.loading
    };

    return details;
  } 

  const { fleetManagerState} = useFleetManagerContext();
  const isEditMode = fleetManagerState.isEditDelegeeMode;

    return (
      <div>
        <DelegationForm 
          onClose={props.onClose} 
          refreshHandler={props.refreshHandler}
          getProducts={getParkingProducts}
          inviteDelegee={delegateParkingRights}
          updateDelegation={updateDelegation}
          getDelegeeDetails={getDelegeeDetails}
          clearDelegeeDetails={clearDelegeeDetails}
          resetBulkImportProgress={resetBulkImportProgress}
          getBulkImportStatus={getBulkImportStatus}
          disposeError={disposeError}
          isEditMode={isEditMode}
          translationContextName="parkingRightsForm"
          delegationFormDetails={getDelegationFormDetails()} />
      </div>
    );
};

const mapStateToProps = (state: RootReducer) => {
  const { parkingProducts } = state;

  return {
    parkingProducts
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  getParkingProducts: (seasonTicketOwnerCrmId: string, language: string) => 
    dispatch(parkingProductsActions.getParkingProducts(seasonTicketOwnerCrmId as string, language)),
  delegateParkingRights: (parkingRights: ParkingRightsRequestModel, callback?: () => void) =>
    dispatch(parkingProductsActions.delegateParkingRights(parkingRights, callback)),
  updateDelegation: (parkingRights: ParkingRightsRequestModel, callback?: () => void) =>
    dispatch(parkingProductsActions.updateDelegation(parkingRights, callback)),
  disposeError: () => dispatch(parkingProductsActions.disposeError()),
  getDelegeeDetails: (registrationId: string, language: string) =>
    dispatch(parkingProductsActions.getDelegeeDetails(registrationId, language)),
  clearDelegeeDetails: () => dispatch(parkingProductsActions.clearDelegeeDetails()),
  resetBulkImportProgress: () => dispatch(parkingProductsActions.resetBulkImportProgress()),
  getBulkImportStatus: (seasonTicketOwnerCrmId: string) => dispatch(parkingProductsActions.getBulkImportStatus(seasonTicketOwnerCrmId))
  }
);
  
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
  
export default connect(mapStateToProps, mapDispatchToProps)(ParkingRightsForm);